import { QueryObserverOptions, useQuery } from "react-query";
import { APIError, APIResponse, API_URL, get } from "../api";
import { Product } from "../@types";

function useProducts(
  options?: QueryObserverOptions<APIResponse<Product[]>, APIError>
) {
  const {
    data: products,
    isError,
    error,
    isLoading,
  } = useQuery<APIResponse<Product[]>, APIError>(
    "all-products",
    () =>
      get(API_URL + "/commerce/all-products", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
    options
  );

  return {
    products,
    isError,
    error,
    isLoading,
  };
}

export default useProducts;
